// extracted by mini-css-extract-plugin
export var childrenContainer = "_48-0";
export var virtualScrollArea = "_48-1";